export const ROUTE_PATHS = {
  LOGIN: '/login',
  AUTH_CALLBACK: '/auth/callback',
  DASHBOARD: '/dashboard',
  TRACKER: '/tracker',
  PROJECTS: '/projects',
  PROJECT_DETAIL: (id: string) => `/projects/${id}`,
  CLIENTS: '/clients',
  CLIENT_DETAIL: (id: string) => `/clients/${id}`,
  CLIENT_PROJECT_DETAIL: (clientId: string, projectId: string) =>
    `/clients/${clientId}/projects/${projectId}`,
  REPORTS: '/reports',
  SMART_REPORT: '/reports/smart',
  TEAM: '/team',
  SETTINGS: '/settings',
} as const;
